module.exports = __webpack_public_path__ + "static/img/bcg.70f2f6e8.webp";